import { render } from "./ProjectParticipationListWidget.vue?vue&type=template&id=e405967a&ts=true"
import script from "./ProjectParticipationListWidget.ts?vue&type=script&lang=ts&external"
export * from "./ProjectParticipationListWidget.ts?vue&type=script&lang=ts&external"

import "./ProjectParticipationListWidget.vue?vue&type=style&index=0&id=e405967a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__